/* eslint react/no-unknown-property:0 */

import _ from "lodash"; 
import React, { Component } from "react";
import ArrowSVG from "../../images/ArrowSVG";
import { Link } from "react-router-dom";
import { withRouter } from "react-router";

class CatalogInputControl extends Component {

  constructor(props) {
    super(props);
    this.validCatalogRefNumLength = 7;
    this.state = {
      input: "",
      link: "/",
      valid: false,
      placeholderText: "ABC-DEF"
    };
  }
  
  componentDidMount() {
    // quick hack to validate the input value after init.
    // value get's set elsewhere in some cases and is not always triggering the 
    // input changed event. 
    setTimeout(() => {
      let inputBox = document.getElementById("catalog-input");
      let value = inputBox && inputBox.value || this.state.input || "";
      let dummyEvent = { target: { value } };
      this.onInputChanged(dummyEvent);    
    }, 50);
  }

  onInputChanged(e) {
    // console.log("23 --->", e.target.value);
    let input = _.get(e, "target.value") || "";
    input = this.formatCatalogRefNumber(input);

    // account for the dash character
    // console.log("28 --->", input, input.length, this.validCatalogRefNumLength);
    let valid = (input && input.length === this.validCatalogRefNumLength);    
    let link = valid? `/${input}`: "";
    
    this.setState({ input, link, valid });
  }

  formatCatalogRefNumber(str) {
    // normalize the str by removeing all non alpha-numeric chars and forcing to uppercase
    str = _.chain(str || "")
      .toUpper()
      .replace(/[^A-Z0-9]/g, "")
      .trim()
      .value();
    console.log("41 --->", str);
    // split str into 2 parts, then join with a hyphen between
    let part1 = str.substring(0, 3);
    let part2 = str.substring(3, 6);
    if (_.size(part1) >= 3 && _.size(part2) > 0) { 
      str = part1 + "-" + part2;
    } else {
      str = part1;
    }
    return str;
  }

  onKeyDown(e) {
    if (e && e.key === "Enter") {
      e.preventDefault();
      e.stopPropagation();
      // TODO: go to the results page
      if (this.state.valid === true) {
        this.props.history.push(this.state.input);
      }
    }
  }

  onSubmit() {
    this.context.router.transitionTo(this.state.input);
  }

  render() {
    return (
      <div className="catalog-input-search-container">
        <div className="playbook-landing-container">
          <input className={ "playbook-input" + (this.state.valid? " valid": "") }
            value={this.state.input} 
            autocomplete="off" 
            autocorrect="off"
            autocapitalize="off"
            spellcheck="false"
            id="catalog-input"
            placeholder={this.state.placeholderText} 
            onChange={(event) => this.onInputChanged(event)}
            onKeyDown={(event) => this.onKeyDown(event)}></input>
          <Link className="playbook-search-button" 
            to={this.state.input}
            style={!this.state.valid ? {pointerEvents: "none"} : null}
            disabled={!this.state.valid}>
            <ArrowSVG />
          </Link>
        </div>
      </div>
    );
  }
}

export default withRouter(CatalogInputControl);



// WEBPACK FOOTER //
// ./src/components/CatalogInputControl/CatalogInputControl.js